import Axios from 'axios';
import Serve from '../app/serve';

async function delCorretores(id_corretor, type) {
  const token = localStorage.getItem('token');
  const app = Serve();
  let data;

  await Axios.post(app + 'excluir_corretores', {
    id_corretor,
    type
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  })
    .then(res => {
      if (res.data.status && res.data.status === (401 || 498)) {
        localStorage.clear();
      } else {
        data = true;
      }
    })
    .catch(function (error) {
      console.log(error);
      data = false
    })

  return data;
};

export default delCorretores;